var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChartAlt = function SvgChartAlt(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.19 25.3a8.78 8.78 0 0 1 10.65 5.88l.08.29 7.9 29.3a4.94 4.94 0 0 1-9.48 2.82l-.08-.25-7.6-28.2-28.43 7.56a4.95 4.95 0 0 1-5.99-3.26l-.07-.24a4.94 4.94 0 0 1 3.26-5.98l.25-.07 29.5-7.85z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.86 30.35a4.93 4.93 0 0 1 6.8-1.6 4.97 4.97 0 0 1 1.73 6.6l-.13.22-32.12 52.08a4.93 4.93 0 0 1-6.8 1.6 4.97 4.97 0 0 1-1.73-6.6l.13-.22zm-54 28.05a4.9 4.9 0 0 1 6.75-1.7 4.96 4.96 0 0 1 1.82 6.56l-.13.23-22.16 37.1a4.9 4.9 0 0 1-6.75 1.7 4.96 4.96 0 0 1-1.82-6.55l.13-.23 22.16-37.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.48 58.42a4.87 4.87 0 0 1 6.77-.1l.19.18L68.6 81.53a5.03 5.03 0 0 1-.08 7.05 4.87 4.87 0 0 1-6.77.1l-.19-.18L39.4 65.47a5.03 5.03 0 0 1 .08-7.05"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChartAlt);
export default ForwardRef;